import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { QueryFilters } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';
import { TokenDistributionSummary } from '../../types';

const END_POINT = '/metric/tokenDistribution';

export type TokenDistributionSummaryDto = TokenDistributionSummary;

const convertTokenDistributionSummaryDtoToTokenDistributionSummary = (
    tokenDistributionSummaryDto: TokenDistributionSummaryDto
): TokenDistributionSummary => {
    return tokenDistributionSummaryDto;
};

const fetchTokenDistributionSummary = async (filters: QueryFilters) => {
    const data = await apiGet<TokenDistributionSummaryDto>(
        `${API_BASE_URL}${END_POINT}`,
        buildUniversalMfaQueryParams(filters)
    );

    return data;
};

export const useTokenDistributionSummary = (filters: QueryFilters): UseQueryResult<TokenDistributionSummary> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.tokenDistributionSummary(filters),
        queryFn: () => fetchTokenDistributionSummary(filters),
        select: convertTokenDistributionSummaryDtoToTokenDistributionSummary
    });
};
